import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import {
	Drawer,
	Box,
	Button,
	List,
	ListItem,
	ListItemText,
	ListSubheader,
	Typography,
	Divider,
	ListItemAvatar,
	ListItemIcon,
} from "@material-ui/core";
import DeviceIcon from '@material-ui/icons/PhoneAndroid';

import { useStyles } from "./styles";
import { useDockerManagementContext } from "../../DockerManagementProvider";
import { selectAllOrgDevicesWithFacilityName } from "../../../../../state/slices/OrgTree";

const DevicesDrawer = () => {
	const classes = useStyles();
	const devices = useSelector(selectAllOrgDevicesWithFacilityName);

	const {
		state: { devicesInfoObj },
		actions: { closeDisplayDevices },
	} = useDockerManagementContext();

	const devicesMap = useMemo(
		() => {
			// First, create a map of facilities to their devices
			const facilitiesMap = {};

			const deviceIds = devicesInfoObj?.deviceIds || [];

			const deviceLookup = devices.reduce((acc, device) => {
				acc[device.deviceId] = device;
				return acc;
			}, {});

			deviceIds.forEach(deviceId => {
				const deviceInfo = deviceLookup[deviceId];
				if (deviceInfo) {
					const { facilityName } = deviceInfo;
					if (!facilitiesMap[facilityName]) {
						facilitiesMap[facilityName] = [];
					}
					facilitiesMap[facilityName].push(deviceInfo);
				} else {
					// Handle devices without facility info
					if (!facilitiesMap['Unknown']) {
						facilitiesMap['Unknown'] = [];
					}
					facilitiesMap['Unknown'].push({ deviceId, deviceName: deviceId });
				}
			});

			// Sort facilities alphabetically
			const sortedFacilities = Object.keys(facilitiesMap).sort();

			// Create the list with facility headers and their devices
			return sortedFacilities.flatMap((facilityName, facilityIndex) => {
				const facilityDevices = facilitiesMap[facilityName];

				return [
					// Facility header
					<ListSubheader key={`facility-${facilityName}`} component="div" disableSticky>
						{facilityName}
					</ListSubheader>,

					// Devices in this facility
					...facilityDevices.map((device, deviceIndex) => (
						<ListItem
							key={device.deviceId}
							// divider={deviceIndex !== facilityDevices.length - 1}
							sx={{ pl: 4 }} // Indent the devices under their facility
						>
							<ListItemIcon><DeviceIcon color="primary" /></ListItemIcon>
							<ListItemText primary={device.deviceName} />
						</ListItem>
					))
				];
			});
		},
		[devicesInfoObj]
	);


	const handleClose = () => {
		closeDisplayDevices();
	};


	const deviceIds = devicesInfoObj?.deviceIds || [];

	return (
		<Drawer
			anchor="right"
			open={!!devicesInfoObj}
			onClose={handleClose}
			classes={{ paper: classes.drawerPaper }}
		>
			<Box display="flex" flexDirection="column" height="100%">

				{/* Title at the top */}
				<Box px={2} py={2}>
					<Typography variant="h6" color="primary">Selected Devices</Typography>
				</Box>
				<Divider />

				{/* Scrollable list area */}
				<Box px={2} py={1} flexGrow={1} style={{ overflowY: "auto" }}>
				<List>
					{/* Group devices by facility */}
					{devicesMap}
				</List>
				</Box>

				<Box mt="auto" p={2} display="flex" justifyContent="flex-end">
					<Button variant="contained" onClick={handleClose}>
						Close
					</Button>
				</Box>
			</Box>
		</Drawer>
	);
};

export default DevicesDrawer;
